import { render, staticRenderFns } from "./loginCallbackThird.vue?vue&type=template&id=1839d429&"
import script from "./loginCallbackThird.vue?vue&type=script&lang=js&"
export * from "./loginCallbackThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports